import { fetchApi } from '@/config/axiosSetting';
import {
  GetInitialVisitAccessoryListQueryParamsType,
  GetInitialVisitAccessoryListQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitAccessoryList/getInitialVisitAccessoryListQuery.type';

export const getInitialVisitAccessoryListFunction = (
  params: GetInitialVisitAccessoryListQueryParamsType,
): Promise<GetInitialVisitAccessoryListQueryResponseType> => {
  return fetchApi.get(`/initial/reports/${params.id}/accessory/`, { params });
};
